import React, { useEffect, useState } from 'react';

import { getNodeTypeLabel } from '@/app/agents/edit/util/nodeTypeUtils';
import { Text } from '@/components/typography/text';
import {
  AgentConfigStepAction,
  AgentConfigStepInputs,
  AgentConfigStepTypeEnum,
  AgentConfigStepVectorDBAction
} from '@/types/agent';


type Props = {
  dbAction: AgentConfigStepVectorDBAction;
  editable: boolean;
  inputs: AgentConfigStepInputs;
  onActionUpdate: <T extends AgentConfigStepAction>( action: T ) => void;
};

export default function ActionVectorDB( props: Props ) {
  const {
    dbAction,
    editable,
    inputs,
    onActionUpdate
  } = props;

  const [ action, setAction ] = useState<AgentConfigStepVectorDBAction>( dbAction );

  useEffect( ()=>{
    setAction( dbAction );
  }, [ dbAction ] );

  const onChange = <T,>( key: keyof AgentConfigStepVectorDBAction, value: T ) => {
    const res = {
      ...action,
      [ key ]: value
    };
    setAction( res );
    onActionUpdate( res );
  };

  const onConvoKeyChange = ( event: React.ChangeEvent<HTMLSelectElement> ) => onChange<string>( 'conversation_key', event.currentTarget.value );
  const onIndexChange = ( event: React.ChangeEvent<HTMLInputElement> ) => onChange<string>( 'index', event.currentTarget.value );
  const onQueryChange = ( event: React.ChangeEvent<HTMLInputElement> ) => onChange<string>( 'query', event.currentTarget.value );

  const renderInputVariables = () => {
    return Object.keys( inputs ).map(
      key => (
        <option key={ key } value={ key }>{ key }</option>
      )
    );
  };

  return (
    <div className='configPane'>
      <Text as='div' className='paneTitle' size='md' weight='bold'>{ getNodeTypeLabel( AgentConfigStepTypeEnum.VECTORDB ) } Action</Text>

      <Text as='label' size='sm' htmlFor='index'>Index</Text>
      <input data-testid='config-edit-panel-action-vectordb-index-input' disabled={ !editable } id='index' onChange={ onIndexChange } type='text' value={ action.index }/>
      <Text as='label' size='sm' htmlFor='query'>Query</Text>
      <input data-testid='config-edit-panel-action-vectordb-query-input' disabled={ !editable } id='query' onChange={ onQueryChange } type='text' value={ action.query }/>
      <Text as='label' size='sm' htmlFor='mapConversation'>Map Conversation</Text>
      <select data-testid='config-edit-panel-action-vectordb-map-conversation-select' disabled={ !editable } id='mapConversation' onChange={ onConvoKeyChange }value={ action.conversation_key } >
        <option value='none'>Do Not Include</option>
        { renderInputVariables() }
      </select><br />
    </div>
  );
}
